module.exports = __webpack_public_path__ + "static/bakoba-filtering-recording-323e13a8df794c723d9032e0b7d98a49.mp4";